import { Field, Form, Formik } from "formik";
import React, { useCallback } from "react";
import { Form as BForm, Col, Row, Modal } from "react-bootstrap";
import * as Yup from "yup";
import TextInput from "../../../../../components/formfields/InputField";
import CustomPicker from "../FreebiesSection/CustomPicker";
import SubmitLoader from "../../../../../components/SubmitLoader";

type modalTypes = {
  show?: boolean;
  setShow?: any;
  customArrayHelper?: any;
  uploadAction?: any;
  editData?: any;
  setFieldValue?: any;
  index?: number;
  uploadNewAction?: any;
};

const formSchema = Yup.object({
  name: Yup.string().required("Title can not be empty"),
  description: Yup.string().required("Description can not be empty"),
  image: Yup.string().required("Please upload image"),
});

const AddTestimonial = ({ show, setShow, customArrayHelper, uploadAction, editData, setFieldValue, index, uploadNewAction }: modalTypes) => {
  const addState = {
    name: editData ? editData.name : "",
    color: editData ? editData.color : "",
    description: editData ? editData.description : "",
    image: editData ? editData.image : "",
    dummyImage: editData ? editData.dummyImage : "",
    oldImage: editData ? editData.oldImage : "",
  };

  const handleSubmit = (values: any, { resetForm }: any) => {
    if (editData) {
      setFieldValue(`testimonials[${index}]`, values);
      setShow(false);
    } else {
      customArrayHelper.push(values);
      resetForm();
      setShow(false);
    }
  };

  // const handleUpload = (event: any, fieldValue: any, name: string) => {
  //   const data = {
  //     file: event.currentTarget.files[0],
  //   };
  //   uploadAction(data, fieldValue, name);
  // };

  const handleUpload = (event: any, fieldValue: any, name: string, oldImage: any) => {
    const formData = new FormData();
    formData.append("file", event.currentTarget.files[0]);
    formData.append("folder", "home-page");
    formData.append("url", oldImage ? oldImage : "");
    uploadNewAction(formData, fieldValue, name);
  };

  const onImageChange = useCallback((event: any, fieldValue: any, name: string, oldImage: any) => {
    if (event.target.files?.[0]) {
      const file = event.target.files[0];
      handleUpload(event, fieldValue, name, oldImage);
      const URL = window.URL || window.webkitURL;
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = function handleImageLoad() {
        // fieldValue(name, event.target.files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          fieldValue("dummyImage", e?.target?.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      };
    }
  }, []);

  const handleRemove = useCallback((field: string, fieldValue: any) => {
    fieldValue(field, "");
    fieldValue("dummyImage", "");
  }, []);

  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {
        setShow(false);
      }}
      className="resource_library_modal theme_popup"
      scrollable
    >
      <Formik enableReinitialize initialValues={addState} validationSchema={formSchema} onSubmit={handleSubmit}>
        {({ values, handleChange, setFieldValue, handleBlur, errors, touched }) => {
          return (
            <>
              <Modal.Header closeButton>
                <Modal.Title className="fw-bold h6">{editData ? "Edit " : "Add "}Testimonial</Modal.Title>
              </Modal.Header>
              <Form className="modal-content h-100">
                <Modal.Body>
                  <Row className="gy-3">
                    <Col lg="6">
                      <BForm.Label>Name</BForm.Label>
                      <Field
                        name="name"
                        component={TextInput}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Name"
                        className="editField"
                      />
                    </Col>
                    <Col lg="6">
                      <CustomPicker setFieldValue={setFieldValue} name="color" value={values.color} label="Background Color" />
                    </Col>

                    <Col sm="12">
                      <BForm.Label>Header Descripation</BForm.Label>
                      <div className="editField mb-2">
                        <Field
                          name="description"
                          component={TextInput}
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter Description"
                          className="editField mb-2"
                          multiline
                        />
                      </div>
                    </Col>
                    <Col sm="12">
                      <label className="form-label">Upload Image</label>
                      {values.dummyImage || values.image ? (
                        <div style={{ maxWidth: "200px" }}>
                          <div className="uploarForm position-relative square overflow-hidden">
                            {values.image ? (
                              <>
                                {" "}
                                <a
                                  className="btn btn-danger btn-sm btn-icon position-absolute top-0 end-0 rounded me-2 mt-2 zindex-1"
                                  onClick={() => {
                                    setFieldValue("oldImage", values?.image);
                                    handleRemove("image", setFieldValue);
                                  }}
                                >
                                  <i className="fa-regular fa-trash-can"></i>
                                </a>
                                <img className="img-fluid position-absolute fitImage h-100 top-0" src={values.dummyImage || values.image} alt="imagessss" />
                              </>
                            ) : (
                              <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                                <SubmitLoader />
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <>
                          {touched?.image && errors.image ? <p className="errorMessage">{`${errors.image}`}</p> : null}

                          <div style={{ maxWidth: "200px" }}>
                            <div className="uploarForm position-relative square overflow-hidden">
                              <input
                                id="file"
                                name="image"
                                type="file"
                                accept="image/x-png,image/gif,image/jpeg"
                                onChange={(e) => onImageChange(e, setFieldValue, "image", values?.oldImage)}
                              />
                              <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                                <i className="fa-light fa-upload fa-2x text-primary"></i>
                                <p className="mb-0 mt-3">Upload Images</p>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                  <a onClick={() => setShow(false)} className="btn btn-danger mx-2">
                    Cancel
                  </a>
                  <button type="submit" className="btn btn-green mx-2">
                    Add
                  </button>
                </Modal.Footer>
              </Form>
            </>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddTestimonial;
